import { configureStore } from "@reduxjs/toolkit";
import storeMenuUrlReducer from './storeMenuUrl';
import permissionSlice from './managePermissionSlice';

const store = configureStore({
  reducer: {
    store_assign_url : storeMenuUrlReducer,
    store_permission_data : permissionSlice,
  },
});

export default store;